angular.module('bmsApp.sm.job')
	.controller('SMCancelJobModalCtrl',
		function ($state,
				  $modalInstance,
				  $scope,
				  SMJobSvc,
				  $q,
				  AppSettingsSvc,
				  job) {


			function init() {
				self.job = job;
				var cancelReasonOptionPromise = SMJobSvc.cancelReason.options().then(function(response) {
					self.options.cancelReasons = response.data.options;
				});
				var appSettings = AppSettingsSvc.index()
					.then(function (response) {
						self.appSettings = response.data.settings;
						self.form.send_email_notification = self.appSettings.send_job_cancellation_email;
					});

				$q.all([
					cancelReasonOptionPromise,
					appSettings
				])
					.then(function () {
						self.loading = false;
					});

			}


			function cancel() {
				$modalInstance.dismiss('cancel');
			}

			function submit() {
				var params = {
					jobId: self.job.id,
					cancelReason: self.form.cancel_reason,
					send_email_notification: self.form.send_email_notification,
				};
				SMJobSvc.cancel.save(params).then(function(response) {
					$modalInstance.close(response.data.sm_job);
				});
			}

			var self = $scope.SMCancelJobCtrl = {
				loading: true,
				form: {},
				options: {},
				job: {},
				methods: {
					init: init,
					cancel: cancel,
					submit: submit
				}
			}

		});
